export default __webpack_public_path__ + "static/media/prod-varient-white.3fcdbfd4.jpg";